import React from "react";
import { Login } from "../../../components";

export const LoginPage = () => {
  return <Login />;
};
